// /bjt/calculator: shows the fields of the way the reader chose. ⛔ Native
// DOM, no React, no figures: the server computes everything.
import { showsWay } from 'utils/examCalculatorForm'

function setup() {
  const form = document.querySelector('[data-bjt-form]')
  if (!form) return

  const update = () => {
    const chosen = form.querySelector('[data-bjt-way-choice]:checked')?.value || 'self'
    form.querySelectorAll('[data-bjt-way]').forEach((group) => {
      const shown = showsWay(group.dataset.bjtWay, chosen)
      group.hidden = !shown
      // A hidden field is not sent, so a stale report cannot reach the server.
      group.querySelectorAll('input, select').forEach((field) => { field.disabled = !shown })
    })
  }

  form.addEventListener('change', update)
  update()
}

document.addEventListener('DOMContentLoaded', setup)
